import { collection, getDocs, updateDoc, doc, serverTimestamp } from 'firebase/firestore';
import { db, auth } from './firebase';

export async function checkAndFixWishlists() {
  const currentUser = auth.currentUser;
  if (!currentUser) {
    return { success: false, error: 'auth.warnings.loginRequiredForFix' };
  }

  const snapshot = await getDocs(collection(db, "wishlists"));
  console.log(`Trovati ${snapshot.size} documenti nella collezione wishlists.`);

  for (const docSnap of snapshot.docs) {
    const ref = doc(db, "wishlists", docSnap.id);
    const data = docSnap.data();
    let updated = false;
    const updates = {};

    if (!("isPublic" in data)) {
      updates.isPublic = false;
      updated = true;
    }
    if (!("likes" in data)) {
      updates.likes = [];
      updated = true;
    }
    if (!("createdAt" in data)) {
      updates.createdAt = serverTimestamp();
      updated = true;
    }
    if (!("userId" in data) || !data.userId) {
      console.warn(`⚠️ Documento ${docSnap.id} ha userId mancante!`);
    }

    if (updated) {
      console.log(`🔧 Documento ${docSnap.id} aggiornato:`, updates);
      await updateDoc(ref, updates);
    }
  }

  return { success: true, updated: 0, total: snapshot.size, message: 'auth.warnings.fixCompleted' };
}